import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthGate } from './components/auth/AuthGate';
import { Layout } from './components/layout/Layout';
import { LoadingSpinner } from './components/ui/Card';

const Login = lazy(() => import('./pages/Login').then(module => ({ default: module.Login })));
const AuthCallback = lazy(() => import('./pages/AuthCallback').then(module => ({ default: module.AuthCallback })));
const Dashboard = lazy(() => import('./pages/Dashboard/index').then(module => ({ default: module.Dashboard })));
const Projects = lazy(() => import('./pages/Projects').then(module => ({ default: module.Projects })));
const ProjectDetail = lazy(() => import('./pages/Projects').then(module => ({ default: module.ProjectDetail })));
const Incomes = lazy(() => import('./pages/Incomes').then(module => ({ default: module.Incomes })));
const Expenses = lazy(() => import('./pages/Expenses').then(module => ({ default: module.Expenses })));
const Parties = lazy(() => import('./pages/Parties').then(module => ({ default: module.Parties })));
const Rules = lazy(() => import('./pages/Rules').then(module => ({ default: module.Rules })));
const RuleGraphPreview = lazy(() => import('./pages/RuleGraphPreview').then(module => ({ default: module.RuleGraphPreview })));
const Reports = lazy(() => import('./pages/Reports').then(module => ({ default: module.Reports })));
const PaymentReport = lazy(() => import('./pages/PaymentReport').then(module => ({ default: module.PaymentReport })));
const Closing = lazy(() => import('./pages/Closing').then(module => ({ default: module.Closing })));
const Settings = lazy(() => import('./pages/Settings').then(module => ({ default: module.Settings })));
const AccountingSettings = lazy(() => import('./pages/AccountingSettings').then(module => ({ default: module.AccountingSettings })));
const ReportIssuerSettingsPage = lazy(() => import('./pages/ReportIssuerSettings').then(module => ({ default: module.ReportIssuerSettingsPage })));
const EnvironmentSettings = lazy(() => import('./pages/EnvironmentSettings').then(module => ({ default: module.EnvironmentSettings })));
const Help = lazy(() => import('./pages/Help').then(module => ({ default: module.Help })));

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/*" element={
            <AuthGate>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/projects" element={<Projects />} />
                  <Route path="/projects/:projectId" element={<ProjectDetail />} />
                  <Route path="/incomes" element={<Incomes />} />
                  <Route path="/expenses" element={<Expenses />} />
                  <Route path="/parties" element={<Parties />} />
                  <Route path="/members" element={<Navigate to="/parties?role=distribution" replace />} />
                  <Route path="/counterparties" element={<Navigate to="/parties?role=counterparty" replace />} />
                  <Route path="/rules" element={<Rules />} />
                  <Route path="/rules/graph-preview" element={<RuleGraphPreview />} />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/payment-report" element={<PaymentReport />} />
                  <Route path="/closing" element={<Closing />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/settings/accounting" element={<AccountingSettings />} />
                  <Route path="/settings/report-issuer" element={<ReportIssuerSettingsPage />} />
                  <Route path="/settings/environment" element={<EnvironmentSettings />} />
                  <Route path="/help" element={<Help />} />
                </Routes>
              </Layout>
            </AuthGate>
          } />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
